module.exports = __webpack_public_path__ + "static/media/videos.2b76f196.png";


//////////////////
// WEBPACK FOOTER
// ../images/screenshots/videos.png
// module id = 654
// module chunks = 0